import Fuse, { type IFuseOptions } from "fuse.js";
import type { RecipeApiItem } from "@recipevault/shared";

// Threshold 0.4 = medium-low fuzziness (locked per Plan 04 §scope decision 14).
// Weights: title 2, ingredients[].name 1, steps[].text 0.5.
export const FUSE_OPTIONS: IFuseOptions<RecipeApiItem> = {
  threshold: 0.4,
  ignoreLocation: true,
  keys: [
    { name: "title", weight: 2 },
    { name: "ingredients.name", weight: 1 },
    { name: "steps.text", weight: 0.5 },
  ],
};

export function makeRecipeFuse(items: RecipeApiItem[]): Fuse<RecipeApiItem> {
  return new Fuse(items, FUSE_OPTIONS);
}
